import { gql } from '@apollo/client';

export default gql`
    {
        Instruments {
            IdInstrumento
            Instrumento
        }
    }
`;